var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBio(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "19px",
    viewBox: "0 0 29 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/ProfileBio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.28486111,2.50597662 C0.635381944,2.50597662 0.115798611,1.95663377 0.115798611,1.36503377 C0.115798611,0.731176623 0.635381944,0.224090909 1.28486111,0.224090909 L10.5940625,0.224090909 C11.2435417,0.224090909 11.763125,0.731176623 11.763125,1.36503377 C11.763125,1.99889091 11.2435417,2.50597662 10.5940625,2.50597662 L1.28486111,2.50597662 Z M1.28486111,8.16843377 C0.635381944,8.16843377 0.115798611,7.66134805 0.115798611,7.02749091 C0.115798611,6.39363377 0.635381944,5.88654805 1.28486111,5.88654805 L10.5940625,5.88654805 C11.2435417,5.88654805 11.763125,6.39363377 11.763125,7.02749091 C11.763125,7.66134805 11.2435417,8.16843377 10.5940625,8.16843377 L1.28486111,8.16843377 Z M1.28486111,13.8731481 C0.635381944,13.8731481 0.115798611,13.3660623 0.115798611,12.7322052 C0.115798611,12.0983481 0.635381944,11.5912623 1.28486111,11.5912623 L10.5940625,11.5912623 C11.2435417,11.5912623 11.763125,12.0983481 11.763125,12.7322052 C11.763125,13.3660623 11.2435417,13.8731481 10.5940625,13.8731481 L1.28486111,13.8731481 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29694444,19.2666961 L13.4638542,19.2666961 C14.1133333,19.2666961 14.6329167,18.7596104 14.6329167,18.1257532 L14.7195139,15.379039 C14.7195139,15.379039 14.7195139,15.379039 14.7195139,15.3367818 C14.7195139,12.5478104 13.0741667,10.1814104 10.7360417,8.99821039 C11.7752083,8.11081039 12.4246875,6.80083896 12.4246875,5.3640961 C12.4246875,2.7018961 10.1731597,0.504524675 7.44534722,0.504524675 C4.71753472,0.504524675 2.46600694,2.7018961 2.46600694,5.3640961 C2.46600694,6.80083896 3.11548611,8.11081039 4.15465278,8.99821039 C1.77322917,10.1814104 0.171180556,12.5900675 0.171180556,15.3367818 L0.171180556,18.0834961 C0.127881944,18.7596104 0.647465278,19.2666961 1.29694444,19.2666961 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-Friend-Request",
    transform: "translate(-507.000000, -537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ProfileBio-Max",
    transform: "translate(507.000000, 532.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_566458_cc-copy",
    transform: "translate(0.000000, 4.640000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey-copy-2",
    transform: "translate(16.638750, 2.689091)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.375000, -15.238182)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 45,
    height: 45
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-4)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.736250, -12.549091)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 45,
    height: 45
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBio);
export default __webpack_public_path__ + "static/media/profileBio.4887f0ffb2ceaeb1db0b451a88eb227b.svg";
export { ForwardRef as ReactComponent };